
{
  "familyId": "TIJD-ANALOOG-GEDETAILLEERD",
  "questions": [
    {
      "id": "TIJD-ANALOOG-GEDETAILLEERD-001",
      "familyId": "TIJD-ANALOOG-GEDETAILLEERD",
      "module": "Tijd",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "klokkijken",
      "subSkill": "klok_analoog_gedetailleerd",
      "questionType": "clock",
      "question": "Hoe laat is het op deze klok?",
      "options": ["10:25", "10:30", "10:20", "11:25"],
      "correctAnswer": 0,
      "data": {
        "clock": {
          "mode": "read_analog_fill",
          "target": { "hours": 10, "minutes": 25, "format": "24h" },
          "analog": { "minuteStep": 5, "showNumbers": true, "showMinuteTicks": true }
        }
      },
      "conceptId": "clock_reading_detailed_25",
      "variantIndex": 1,
      "citoDifficulty": 0.18,
      "citoDiscrimination": 0.76,
      "stimulusAids": [{ "type": "clock", "data": { "hours": 10, "minutes": 25 } }],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Minuten precies tellen",
            "content": "De kleine wijzer staat tussen de 10 en de 11, dus het uur is 10. De grote wijzer wijst naar de 5. Tel de minuten: 5 × 5 = 25 minuten. Het antwoord is 10:25."
          },
          "showWhen": "wrong"
        }
      ],
      "feedback": {
        "explanationText": "De kleine wijzer staat tussen de 10 en de 11, dus het uur is 10. De grote wijzer wijst naar de 5. Tel de minuten: 5 × 5 = 25 minuten. Het is 10:25.",
        "distractorExplanations": {
          "0": "Correct! De kleine wijzer staat bij de 10 en de grote wijzer bij de 5 (25 minuten).",
          "1": "Bijna! De grote wijzer staat op de 5, niet op de 6. Tel de minuten: 5 × 5 = 25, niet 30.",
          "2": "Let op: de grote wijzer staat op de 5, niet op de 4. Tel de minuten: 5 × 5 = 25, niet 20.",
          "3": "Let op de kleine wijzer: die staat tussen de 10 en de 11, niet tussen de 11 en de 12. Het uur is 10, niet 11."
        }
      }
    },
    {
      "id": "TIJD-ANALOOG-GEDETAILLEERD-002",
      "familyId": "TIJD-ANALOOG-GEDETAILLEERD",
      "module": "Tijd",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "klokkijken",
      "subSkill": "klok_analoog_gedetailleerd",
      "questionType": "clock",
      "question": "Hoe laat is het?",
      "options": ["03:40", "03:45", "03:35", "04:40"],
      "correctAnswer": 0,
      "data": {
        "clock": {
          "mode": "read_analog_fill",
          "target": { "hours": 3, "minutes": 40, "format": "24h" },
          "analog": { "minuteStep": 5, "showNumbers": true, "showMinuteTicks": true }
        }
      },
      "conceptId": "clock_reading_detailed_40",
      "variantIndex": 2,
      "citoDifficulty": 0.20,
      "citoDiscrimination": 0.76,
      "stimulusAids": [{ "type": "clock", "data": { "hours": 3, "minutes": 40 } }],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "40 minuten aflezen",
            "content": "De kleine wijzer staat tussen de 3 en de 4, dus het uur is 3. De grote wijzer wijst naar de 8. Tel de minuten: 8 × 5 = 40 minuten. Het antwoord is 03:40."
          },
          "showWhen": "wrong"
        }
      ],
      "feedback": {
        "explanationText": "De kleine wijzer staat tussen de 3 en de 4, dus het uur is 3. De grote wijzer wijst naar de 8. Tel de minuten: 8 × 5 = 40 minuten. Het is 03:40.",
        "distractorExplanations": {
          "0": "Correct! De kleine wijzer staat bij de 3 en de grote wijzer bij de 8 (40 minuten).",
          "1": "Bijna! De grote wijzer staat op de 8, niet op de 9. Tel de minuten: 8 × 5 = 40, niet 45.",
          "2": "Let op: de grote wijzer staat op de 8, niet op de 7. Tel de minuten: 8 × 5 = 40, niet 35.",
          "3": "Let op de kleine wijzer: die staat tussen de 3 en de 4, niet tussen de 4 en de 5. Het uur is 3, niet 4."
        }
      }
    },
    {
      "id": "TIJD-ANALOOG-GEDETAILLEERD-003",
      "familyId": "TIJD-ANALOOG-GEDETAILLEERD",
      "module": "Tijd",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "klokkijken",
      "subSkill": "klok_analoog_gedetailleerd",
      "questionType": "clock",
      "question": "Hoe laat is het op de klok?",
      "options": ["07:10", "07:15", "07:05", "08:10"],
      "correctAnswer": 0,
      "data": {
        "clock": {
          "mode": "read_analog_fill",
          "target": { "hours": 7, "minutes": 10, "format": "24h" },
          "analog": { "minuteStep": 5, "showNumbers": true, "showMinuteTicks": true }
        }
      },
      "conceptId": "clock_reading_detailed_10",
      "variantIndex": 3,
      "citoDifficulty": 0.16,
      "citoDiscrimination": 0.78,
      "stimulusAids": [{ "type": "clock", "data": { "hours": 7, "minutes": 10 } }],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "10 minuten aflezen",
            "content": "De kleine wijzer staat tussen de 7 en de 8, dus het uur is 7. De grote wijzer wijst naar de 2. Tel de minuten: 2 × 5 = 10 minuten. Het antwoord is 07:10."
          },
          "showWhen": "wrong"
        }
      ],
      "feedback": {
        "explanationText": "De kleine wijzer staat tussen de 7 en de 8, dus het uur is 7. De grote wijzer wijst naar de 2. Tel de minuten: 2 × 5 = 10 minuten. Het is 07:10.",
        "distractorExplanations": {
          "0": "Correct! De kleine wijzer staat bij de 7 en de grote wijzer bij de 2 (10 minuten).",
          "1": "Bijna! De grote wijzer staat op de 2, niet op de 3. Tel de minuten: 2 × 5 = 10, niet 15.",
          "2": "Let op: de grote wijzer staat op de 2, niet op de 1. Tel de minuten: 2 × 5 = 10, niet 5.",
          "3": "Let op de kleine wijzer: die staat tussen de 7 en de 8, niet tussen de 8 en de 9. Het uur is 7, niet 8."
        }
      }
    },
    {
      "id": "TIJD-ANALOOG-GEDETAILLEERD-004",
      "familyId": "TIJD-ANALOOG-GEDETAILLEERD",
      "module": "Tijd",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "klokkijken",
      "subSkill": "klok_analoog_gedetailleerd",
      "questionType": "clock",
      "question": "Hoe laat is het?",
      "options": ["11:55", "11:50", "12:00", "11:45"],
      "correctAnswer": 0,
      "data": {
        "clock": {
          "mode": "read_analog_fill",
          "target": { "hours": 11, "minutes": 55, "format": "24h" },
          "analog": { "minuteStep": 5, "showNumbers": true, "showMinuteTicks": true }
        }
      },
      "conceptId": "clock_reading_detailed_55",
      "variantIndex": 4,
      "citoDifficulty": 0.22,
      "citoDiscrimination": 0.74,
      "stimulusAids": [{ "type": "clock", "data": { "hours": 11, "minutes": 55 } }],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "55 minuten aflezen",
            "content": "De kleine wijzer staat bijna bij de 12, maar nog niet helemaal. Het uur is dus 11. De grote wijzer wijst naar de 11. Tel de minuten: 11 × 5 = 55 minuten. Het antwoord is 11:55 (5 voor 12)."
          },
          "showWhen": "wrong"
        }
      ],
      "feedback": {
        "explanationText": "De kleine wijzer staat bijna bij de 12, maar nog niet helemaal. Het uur is dus 11. De grote wijzer wijst naar de 11. Tel de minuten: 11 × 5 = 55 minuten. Het is 11:55 (5 voor 12).",
        "distractorExplanations": {
          "0": "Correct! De kleine wijzer staat nog bij de 11 en de grote wijzer bij de 11 (55 minuten).",
          "1": "Bijna! De grote wijzer staat op de 11, niet op de 10. Tel de minuten: 11 × 5 = 55, niet 50.",
          "2": "Let op de grote wijzer: die staat op de 11 (55 minuten), niet op de 12 (0 minuten). Het is bijna 12 uur, maar nog niet helemaal.",
          "3": "Let op: de grote wijzer staat op de 11, niet op de 9. Tel de minuten: 11 × 5 = 55, niet 45."
        }
      }
    },
    {
      "id": "TIJD-ANALOOG-GEDETAILLEERD-005",
      "familyId": "TIJD-ANALOOG-GEDETAILLEERD",
      "module": "Tijd",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "klokkijken",
      "subSkill": "klok_analoog_gedetailleerd",
      "questionType": "clock",
      "question": "Hoe laat is het op deze klok?",
      "options": ["02:35", "02:30", "02:40", "03:35"],
      "correctAnswer": 0,
      "data": {
        "clock": {
          "mode": "read_analog_fill",
          "target": { "hours": 2, "minutes": 35, "format": "24h" },
          "analog": { "minuteStep": 5, "showNumbers": true, "showMinuteTicks": true }
        }
      },
      "conceptId": "clock_reading_detailed_35",
      "variantIndex": 5,
      "citoDifficulty": 0.19,
      "citoDiscrimination": 0.76,
      "stimulusAids": [{ "type": "clock", "data": { "hours": 2, "minutes": 35 } }],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "35 minuten aflezen",
            "content": "De kleine wijzer staat tussen de 2 en de 3, dus het uur is 2. De grote wijzer wijst naar de 7. Tel de minuten: 7 × 5 = 35 minuten. Het antwoord is 02:35."
          },
          "showWhen": "wrong"
        }
      ],
      "feedback": {
        "explanationText": "De kleine wijzer staat tussen de 2 en de 3, dus het uur is 2. De grote wijzer wijst naar de 7. Tel de minuten: 7 × 5 = 35 minuten. Het is 02:35.",
        "distractorExplanations": {
          "0": "Correct! De kleine wijzer staat bij de 2 en de grote wijzer bij de 7 (35 minuten).",
          "1": "Bijna! De grote wijzer staat op de 7, niet op de 6. Tel de minuten: 7 × 5 = 35, niet 30.",
          "2": "Let op: de grote wijzer staat op de 7, niet op de 8. Tel de minuten: 7 × 5 = 35, niet 40.",
          "3": "Let op de kleine wijzer: die staat tussen de 2 en de 3, niet tussen de 3 en de 4. Het uur is 2, niet 3."
        }
      }
    },
    {
      "id": "TIJD-ANALOOG-GEDETAILLEERD-006",
      "familyId": "TIJD-ANALOOG-GEDETAILLEERD",
      "module": "Tijd",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "klokkijken",
      "subSkill": "klok_analoog_gedetailleerd",
      "questionType": "clock",
      "question": "Hoe laat is het?",
      "options": ["08:50", "08:45", "08:55", "09:50"],
      "correctAnswer": 0,
      "data": {
        "clock": {
          "mode": "read_analog_fill",
          "target": { "hours": 8, "minutes": 50, "format": "24h" },
          "analog": { "minuteStep": 5, "showNumbers": true, "showMinuteTicks": true }
        }
      },
      "conceptId": "clock_reading_detailed_50",
      "variantIndex": 6,
      "citoDifficulty": 0.21,
      "citoDiscrimination": 0.75,
      "stimulusAids": [{ "type": "clock", "data": { "hours": 8, "minutes": 50 } }],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "50 minuten aflezen",
            "content": "De kleine wijzer staat bijna bij de 9, maar nog niet helemaal. Het uur is dus 8. De grote wijzer wijst naar de 10. Tel de minuten: 10 × 5 = 50 minuten. Het antwoord is 08:50 (10 voor 9)."
          },
          "showWhen": "wrong"
        }
      ],
      "feedback": {
        "explanationText": "De kleine wijzer staat bijna bij de 9, maar nog niet helemaal. Het uur is dus 8. De grote wijzer wijst naar de 10. Tel de minuten: 10 × 5 = 50 minuten. Het is 08:50 (10 voor 9).",
        "distractorExplanations": {
          "0": "Correct! De kleine wijzer staat nog bij de 8 en de grote wijzer bij de 10 (50 minuten).",
          "1": "Bijna! De grote wijzer staat op de 10, niet op de 9. Tel de minuten: 10 × 5 = 50, niet 45.",
          "2": "Let op: de grote wijzer staat op de 10, niet op de 11. Tel de minuten: 10 × 5 = 50, niet 55.",
          "3": "Let op de kleine wijzer: die staat tussen de 8 en de 9, niet tussen de 9 en de 10. Het uur is 8, niet 9."
        }
      }
    },
    {
      "id": "TIJD-ANALOOG-GEDETAILLEERD-007",
      "familyId": "TIJD-ANALOOG-GEDETAILLEERD",
      "module": "Tijd",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "klokkijken",
      "subSkill": "klok_analoog_gedetailleerd",
      "questionType": "multiple_choice",
      "question": "Hoe laat is het op deze klok?",
      "options": ["06:20", "06:25", "06:15", "07:20"],
      "correctAnswer": 0,
      "data": {
        "clock": {
          "mode": "read_analog_fill",
          "target": { "hours": 6, "minutes": 20, "format": "24h" },
          "analog": { "minuteStep": 5, "showNumbers": true, "showMinuteTicks": true }
        }
      },
      "stimulusAids": [{ "type": "clock", "data": { "hours": 6, "minutes": 20 } }],
      "conceptId": "clock_reading_detailed_20_mc",
      "variantIndex": 7,
      "citoDifficulty": 0.19,
      "citoDiscrimination": 0.77,
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "tijd.minuut-teller-een-naast", "label": "Telt de grote wijzer één streep verkeerd (4 i.p.v. 5)", "optionIndex": 1 },
          { "id": "tijd.minuut-teller-een-naast", "label": "Telt de grote wijzer één streep verkeerd (3 i.p.v. 4)", "optionIndex": 2 },
          { "id": "tijd.uur-een-te-hoog", "label": "Leest het uur één te hoog af", "optionIndex": 3 }
        ]
      },
      "supportAids": [{
        "type": "rule", "showWhen": "wrong",
        "data": { "title": "20 minuten aflezen", "content": "De kleine wijzer staat tussen de 6 en de 7, dus het uur is 6. De grote wijzer wijst naar de 4. Tel de minuten: 4 × 5 = 20 minuten. Het antwoord is 06:20." }
      }],
      "feedback": {
        "explanationText": "De kleine wijzer staat tussen de 6 en de 7, dus het uur is 6. De grote wijzer wijst naar de 4. Tel de minuten: 4 × 5 = 20 minuten. Het is 06:20.",
        "solutionSteps": [
          "Kijk naar de kleine wijzer: die staat tussen de 6 en de 7 → het uur is 6",
          "Kijk naar de grote wijzer: die wijst naar de 4 → 4 × 5 = 20 minuten",
          "Het is 06:20"
        ],
        "distractorExplanations": {
          "0": "Correct! De kleine wijzer staat bij de 6 en de grote wijzer bij de 4 (20 minuten). Dat is 06:20.",
          "1": "Bijna! De grote wijzer staat op de 4, niet op de 5. Tel nauwkeurig: 4 × 5 = 20, niet 25 minuten.",
          "2": "Let op: de grote wijzer staat op de 4, niet op de 3. Tel nauwkeurig: 4 × 5 = 20, niet 15 minuten.",
          "3": "Let op de kleine wijzer: die staat tussen de 6 en de 7, niet tussen de 7 en de 8. Het uur is 6, niet 7."
        }
      }
    },
    {
      "id": "TIJD-ANALOOG-GEDETAILLEERD-008",
      "familyId": "TIJD-ANALOOG-GEDETAILLEERD",
      "module": "Tijd",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "klokkijken",
      "subSkill": "klok_analoog_gedetailleerd",
      "questionType": "multiple_choice",
      "question": "Hoe laat is het op deze klok?",
      "options": ["01:05", "01:25", "01:10", "12:05"],
      "correctAnswer": 0,
      "data": {
        "clock": {
          "mode": "read_analog_fill",
          "target": { "hours": 1, "minutes": 5, "format": "24h" },
          "analog": { "minuteStep": 5, "showNumbers": true, "showMinuteTicks": true }
        }
      },
      "stimulusAids": [{ "type": "clock", "data": { "hours": 1, "minutes": 5 } }],
      "conceptId": "clock_reading_detailed_05_mc",
      "variantIndex": 8,
      "citoDifficulty": 0.23,
      "citoDiscrimination": 0.75,
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "tijd.streep-als-minuut", "label": "Leest de streep '1' als 1 minuut i.p.v. 5", "optionIndex": 2 },
          { "id": "tijd.uur-minuut-omgewisseld", "label": "Wisselt de waarde van de wijzers om", "optionIndex": 1 },
          { "id": "tijd.uur-een-te-laag", "label": "Leest het uur als 12 i.p.v. 1", "optionIndex": 3 }
        ]
      },
      "supportAids": [{
        "type": "rule", "showWhen": "wrong",
        "data": { "title": "5 minuten aflezen", "content": "De kleine wijzer staat net voorbij de 1, dus het uur is 1. De grote wijzer wijst naar de 1. Tel de minuten: 1 × 5 = 5 minuten. Elk cijfer op de klok is 5 minuten. Het antwoord is 01:05." }
      }],
      "feedback": {
        "explanationText": "De kleine wijzer staat net voorbij de 1, dus het uur is 1. De grote wijzer wijst naar de 1 — en elk cijfer is 5 minuten: 1 × 5 = 5 minuten. Het is 01:05.",
        "solutionSteps": [
          "Kijk naar de kleine wijzer: die staat net voorbij de 1 → het uur is 1",
          "Kijk naar de grote wijzer: die wijst naar de 1 → 1 × 5 = 5 minuten",
          "Het is 01:05"
        ],
        "distractorExplanations": {
          "0": "Correct! De kleine wijzer staat bij de 1 en de grote wijzer bij de 1 (1 × 5 = 5 minuten). Dat is 01:05.",
          "1": "Je wisselde de wijzers om. De korte wijzer geeft het uur (1), de lange wijzer de minuten (5). 01:25 zou de lange wijzer op de 5 vragen, maar die staat op de 1.",
          "2": "Je las de streep '1' als 1 minuut. Maar elk genummerd streepje is 5 minuten: de grote wijzer op de 1 = 1 × 5 = 5 minuten, dus :05, niet :10.",
          "3": "Je las het uur als 12. Maar de kleine wijzer staat net voorbij de 1, niet bij de 12. Het uur is 1, niet 12."
        }
      }
    }
  ]
}
